import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth';
import { Button } from './ui/button';
import { Download, Wallet, Home, Shield, LogOut, Sparkles, History, Ruler, MessageCircle } from 'lucide-react';

export default function NavBar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const onLogout = async () => {
    await logout();
    navigate('/');
  };

  const navItem = (to, label, Icon, testid) => {
    const active = location.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${
          active
            ? 'bg-primary/15 text-primary border border-primary/30'
            : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
        }`}
      >
        <Icon className="w-4 h-4" />
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-white/5 bg-background/70 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
        <Link to={user ? '/dashboard' : '/'} className="flex items-center gap-2" data-testid="logo-link">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-fuchsia-500 via-purple-500 to-indigo-500 flex items-center justify-center shadow-lg shadow-purple-500/30">
            <Sparkles className="w-4 h-4 text-white" />
          </div>
          <span className="logo-text">CihanStock</span>
        </Link>

        {user && (
          <nav className="hidden md:flex items-center gap-1">
            {navItem('/dashboard', 'Panel', Home, 'nav-dashboard')}
            {navItem('/search', 'Premium İndir', Download, 'nav-search')}
            {navItem('/tools/resize', 'Ölçü Numunesi', Ruler, 'nav-resize')}
            {navItem('/history', 'Geçmiş', History, 'nav-history')}
            {navItem('/balance', 'Bakiye', Wallet, 'nav-balance')}
            {navItem('/support', 'Destek', MessageCircle, 'nav-support')}
            {user.role === 'admin' && navItem('/admin', 'Admin', Shield, 'nav-admin')}
          </nav>
        )}

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <div className="hidden sm:flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10" data-testid="navbar-balance">
                <Wallet className="w-3.5 h-3.5 text-emerald-400" />
                <span className="text-xs font-semibold tabular-nums">{(user.balance_tl || 0).toFixed(2)} TL</span>
              </div>
              <Link to="/profile" data-testid="navbar-profile-link" className="hidden lg:block text-xs text-muted-foreground hover:text-foreground truncate max-w-[160px]" title={user.email}>
                {user.email}
              </Link>
              <Button variant="ghost" size="sm" onClick={onLogout} data-testid="logout-btn">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-btn">
                <Button variant="ghost" size="sm">Giriş Yap</Button>
              </Link>
              <Link to="/register" data-testid="nav-register-btn">
                <Button size="sm" className="bg-gradient-to-r from-fuchsia-500 to-indigo-500 hover:from-fuchsia-600 hover:to-indigo-600">
                  Üye Ol
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

